// @ts-strict-ignore
import { AdSlot, AdSlotStatus } from '../../models';
import { logger } from '../../utils';
import { context } from '../../services';

export function getAdType(
	event: googletag.events.SlotRenderEndedEvent,
	iframe: HTMLIFrameElement | null,
	adSlot?: AdSlot,
): string {
	let isIframeAccessible = false;

	if (event.isEmpty) {
		return checkForStatusCollapseOrNoAd(adSlot);
	}

	try {
		isIframeAccessible = !!iframe.contentWindow.document.querySelector;
	} catch (e) {
		logger('gpt-provider', 'getAdType', 'iframe is not accessible');
	}

	if (isIframeAccessible && iframe.contentWindow.AdEngine_adType) {
		return iframe.contentWindow.AdEngine_adType;
	}

	return AdSlotStatus.STATUS_SUCCESS;
}

function checkForStatusCollapseOrNoAd(slot?: AdSlot) {
	if (
		context.get('experiments.refreshCollapseExperiment') &&
		slot &&
		!slot.isRefreshAttemptLimitReached()
	) {
		logger('gpt-provider', 'Refresh experiment active. Returning no-ad event on isEmpty slot.');
		// We should return an Ad Status from here, otherwise we'll return STATUS_SUCCESS or STATUS_COLLAPSE
		// This event gets returned into the slotRenderEnded event listener function.
		// Reference - tag.addEventListener('slotRenderEnded', ...)
		return AdSlotStatus.STATUS_NO_AD;
	}
	return AdSlotStatus.STATUS_COLLAPSE;
}
